import { Grid, Typography } from "@mui/material";
import axios from 'axios';
import { useNavigate } from "react-router-dom";
export default function Signin() {

    var navi = useNavigate();
    var url = `http://localhost:${process.env?.PORT || 3000}/`;


    function loginAsAdmin(e) {
        e.preventDefault();
        var data = new FormData(e.currentTarget);
        var uid = data.get('uid');
        var password = data.get('password');
        // console.log(uid,password)
        axios.post(url + 'loginAsAdmin', {
            uid: uid,
            password: password
        }).then((succ) => {
            if (succ.data.response == 'failed') {
                alert(succ.data.reason);
            } else {
                localStorage.setItem('adminId', succ.data.id);
                console.log('admin added to localStorage');
                navi('/Admin/Dashboard');
            }
        })
    }

    return (
        <>

            <Grid container className='signinbackground' justifyContent={'center'} alignItems={'center'} height={'100vh'}>

                <Grid size={{ lg: 8 }} container bgcolor={'white'} borderRadius={2} minHeight={'40vh'}>
                    <Grid size={{ lg: 6 }} className='p-4'>
                        <Typography variant="h4">Log in</Typography>
                        <form className="mt-4" onSubmit={loginAsAdmin}>
                            <input type="text" name="uid" className="form-control py-2" placeholder="Enter your user id" />
                            <input type="text" name="password" className="form-control py-2 mt-3" placeholder="Enter your password" />
                            <button type="submit" className="btn-admin-navy w-100 py-2 mt-3">Log in</button>
                        </form>
                    </Grid>
                    <Grid size={{ lg: 6 }} borderLeft={'1px solid black'}>
                    </Grid>
                </Grid>
            </Grid>

        </>
    )

}